import { render, staticRenderFns } from "./VerificationLogin.vue?vue&type=template&id=2212ff9c&scoped=true&"
import script from "./VerificationLogin.vue?vue&type=script&lang=js&"
export * from "./VerificationLogin.vue?vue&type=script&lang=js&"
import style0 from "./VerificationLogin.vue?vue&type=style&index=0&id=2212ff9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212ff9c",
  null
  
)

export default component.exports